import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from 'src/app/layout/loading/loading.service';
import { DialogModalService } from 'src/app/shared/dialog-modal/dialog-modal.service';
import { Utility } from 'src/app/shared/utility/utility';
import { MstUserDTO } from 'src/app/models/MstUser';
import { SrcPersonalInfInpService } from '../src-personal-inf-inp/src-personal-inf-inp.service';
import * as moment from 'moment';
import { InfoHTRsvDTO } from 'src/app/models/InfoHTRsv';
import { ScreenMode } from 'src/app/shared/screen-mode';
import { GetIMstHTOrg } from 'src/app/store/actions/mstHTOrg.action';
import { IAppState } from 'src/app/store/states/app.state';
import { Store } from '@ngrx/store';
import { DialogResult } from 'src/app/shared/dialog-modal/dialog-types';
import { DeactivateGuard } from 'src/app/can-deactivate-guard.service';
import { Observable } from 'rxjs';
import { SrcReservationDetailService } from '../src-reservation-detail/src-reservation-detail.service';
/* 20231006 add #19525 start */ 
import { CommonService } from './../../../../services/common.service';
/* 20231006 add #19525 end */ 

@Component({
  selector: 'app-src-personal-inf-inp',
  templateUrl: './src-personal-inf-inp.component.html',
  styleUrls: ['./src-personal-inf-inp.component.scss']
})
export class SrcPersonalInfInpComponent implements OnInit, DeactivateGuard {
  objUser = new MstUserDTO();
  objRsv = new InfoHTRsvDTO();
  typeMode = 1; // 1: add ; 2: edit; 3: e dit confirm
  lstPostal: any[] = [];
  isConsulName = false;
  isKanaName = false;
  isKanaName2 = false;
  isDateOfBirth = false;
  isGender = false;
  isPhoneNum = false;
  isPostalCode = false;
  isAdress1 = false;
  dataReservation: any;
  HTOrgCode: any;
  RsvDateParam: any;
  RsvNumParam: any;
  isShowKanaName = false;
  rgxKatakanaFullW = /^([ァ-ン]|[０-９])+$/;
  rgxKatakanaHalfW = /^([ｧ-ﾝﾞﾟ])+$/;
  isRedirect = false;
  isRedirecting = false;
  objUserInit = new MstUserDTO();
  constructor(
    private router: Router,
    public util: Utility,
    private loadingSrv: LoadingService,
    private dialogModalService: DialogModalService,
    public trans: TranslateService,
    public personalInfInpService: SrcPersonalInfInpService,
    private routeActived: ActivatedRoute,
    private store: Store<IAppState>,
    private rsvDetailService: SrcReservationDetailService,
    /* 20231006 add #19525 start */ 
    private common: CommonService,
    /* 20231006 add #19525 end */ 
  ) { }

  ngOnInit(): void {
    this.util.resetZoomBrowser();
    this.preventButtonBackBrowser()
    const strHTOrgCode = sessionStorage.getItem('HTOrgCode');
    const dataLocal = sessionStorage.getItem('DataReservation');
    if (!this.util.isNullOrEmpty(strHTOrgCode) && !this.util.isNullOrEmpty(dataLocal)) {
      this.HTOrgCode = strHTOrgCode;
      this.dataReservation = JSON.parse(dataLocal);
      this.typeMode = 1;
      const strMode = this.routeActived.snapshot.queryParams.mode;
      if (!this.util.isNullOrEmpty(this.dataReservation.typeReservation) && strMode === ScreenMode.Edit) {
        this.typeMode = 2;
      } else if (strMode === ScreenMode.Edit && this.util.isNullOrBlank(this.dataReservation.typeReservation)
        && !this.util.isNullOrEmpty(this.dataReservation.RsvNum)) {
        this.typeMode = 3;
        const dataLocalOld = sessionStorage.getItem('DataReservationOld');
        const dataOld = JSON.parse(dataLocalOld);
        if (!this.util.isNullOrEmpty(dataOld)) {
          this.RsvDateParam = dataOld.RsvDate;
          this.RsvNumParam = dataOld.RsvNum;
        }
      }
      if ((this.util.isNullOrEmpty(this.dataReservation.objRsv) && this.dataReservation.typeReservation === 1)
        || (this.typeMode === 2 && this.util.isNullOrEmpty(this.dataReservation.isReservationDetail))
        || (strMode !== ScreenMode.Edit && this.util.isNullOrBlank(this.dataReservation.typeReservation))) {
        this.router.navigateByUrl('404');
        return;
      }
      const objHTOrg = {
        HTOrgCode: null,
        HTOrgName: this.dataReservation.HTOrgName,
      };
      this.store.dispatch(new GetIMstHTOrg(objHTOrg));
      if (this.dataReservation.typeReservation === 1 || !this.util.isNullOrEmpty(this.dataReservation.objRsv)) {
        this.objRsv = this.dataReservation.objRsv;
      }
      if (!this.util.isNullOrEmpty(this.dataReservation.objUser)) {
        this.objUser = this.dataReservation.objUser;
        if (this.dataReservation.CountryCode === 'JP' || this.objUser.CountryCode === 'JP') {
          this.isShowKanaName = true;
        }
        this.getAdress1();
      } else {
        this.getInfoUser();
      }
      setTimeout(() => {
        this.util.addPerfectScrollBar();
        $('.scrollbar').scrollTop(0);
      }, 100);
    } else {
      this.router.navigateByUrl('404');
    }
    /* 20250213 #18640 add start */
    this.objUser.PostalCode = this.util.formatPostal(this.objUser.PostalCode);
    /* 20250213 #18640 add end */
  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    window.history.forward()
  }
  getInfoUser() {
    if (!this.util.isNullOrEmpty(localStorage.ExamineauthorizationData)) {
      this.loadingSrv.setDisplay(true);
      this.isShowKanaName = false;
      this.personalInfInpService.getMstUser().subscribe(data => {
        if (data) {
          this.objUser = data;
          this.objUser.ConsulName = data.Name;
          this.objUser.WebRsvNote = null;
          this.objUser.PostalCode = this.util.formatPostal(this.objUser.PostalCode);
          if (this.objUser.CountryCode === 'JP') {
            this.isShowKanaName = true;
          }
          this.getAdress1();
          this.objUserInit = JSON.parse(JSON.stringify(this.objUser));
        }
        this.loadingSrv.setDisplay(false);
      });
    }
  }
  getAdress1() {
    if (!this.util.isNullOrEmpty(this.objUser.Adress1)) {
      this.lstPostal = [{ Address: this.objUser.Adress1 }];
    }
  }
  FocusOutDateOfBirth(value) {
    if (!this.util.isNullOrEmpty(value)) {
      this.objUser.DateOfBirth = moment(value).format('YYYY/MM/DD');
    } else {
      this.objUser.DateOfBirth = null;
    }
  }
  setValuePhoneNum(value) {
    this.objUser.PhoneNum = value;
    if (!this.util.isNullOrEmpty(this.objUser.PhoneNum)) {
      this.isPhoneNum = false;
    }
  }
  SearchAddress() {
    if (!this.util.isNullOrEmpty(this.objUser.PostalCode)) {
      this.loadingSrv.setDisplay(true);
      const strCode = JSON.parse(JSON.stringify(this.objUser.PostalCode));
      this.personalInfInpService.SearchAddress(strCode.replace(' ', '')).subscribe(
        res => {
          this.lstPostal = [];
          if (!this.util.isNullOrEmpty(res) && res.length > 0) {
            this.lstPostal = res;
          } else if (!this.util.isNullOrEmpty(this.objUser.Adress1)) {
            this.lstPostal = [{ Address: this.objUser.Adress1 }];
          }
          setTimeout(() => {
            $('#Adress1').focus();
          }, 1);
          this.loadingSrv.setDisplay(false);
        },
        err => {
          this.loadingSrv.setDisplay(false);
        }
      );
    }
  }
  SetValueAddress(pVal) {
    this.objUser.Adress1 = pVal;
  }
  ButtonBack() {
    this.isRedirecting = true;
    if (this.typeMode === 2) {
      this.router.navigateByUrl('reservation-detail');
    } else if (this.typeMode === 3) {
      const dataLocalOld = sessionStorage.getItem('DataReservationOld');
      if (!this.util.isNullOrEmpty(dataLocalOld)) {
        const dataOld = JSON.parse(dataLocalOld);
        this.dataReservation.objUser = dataOld.objUser;
        sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
      }
      this.router.navigate(['reservation-detail'], {
        queryParams: {
          mode: ScreenMode.Edit, date: this.RsvDateParam, num: this.RsvNumParam, htorgcode: this.HTOrgCode
        }
      });
    } else {
      // this.objUser.DateOfBirth = moment(this.objUser.DateOfBirth).format('YYYYMMDD');
      // this.dataReservation.objUser = this.objUser;
      // sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
      if (this.dataReservation.typeReservation === 1) {
        this.router.navigateByUrl('insurance-inp');
      } else if (this.dataReservation.typeReservation === 2) {
        this.router.navigate(['insurance-sel'], {
          queryParams: {
            htorgcode: this.HTOrgCode
          }
        });
      }
    }
  }
  ButtonNext() {
    //20231024 #18640 add strat
    this.objUser.PostalCode = this.objUser.PostalCode.replace(/[^\d.]/g,"");
    //20231024 #18640 add end
    if (!this.checkValidate()) {
      this.loadingSrv.setDisplay(true);
      const objSearch = {
        HTOrgCode: this.HTOrgCode,
        CoCode: this.objRsv?.CoCode,
        DateOfBirth: moment(this.objUser.DateOfBirth).format('YYYYMMDD'),
        Gender: this.objUser.Gender,
        PersonFamilyDiv: this.objRsv?.PersonFamilyDiv,
      };
      this.personalInfInpService.CheckExistCourse(objSearch).subscribe(data => {
        if (data > 0) {
          this.objUser.DateOfBirth = moment(this.objUser.DateOfBirth).format('YYYYMMDD');
          this.dataReservation.objUser = this.objUser;
          sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
          this.isRedirecting = true;
          this.router.navigateByUrl('exam-course-sel');
        } else {
          this.dialogModalService.openErrorModal(this.trans.instant('MESS_ERR_SELECTED_COURSE_NOT_EXIST'));
        }
        this.loadingSrv.setDisplay(false);
      }, err => {
        this.loadingSrv.setDisplay(false);
      });
    }
  }

  /* 20240918 #20724 add start */
  /* 20241106 #20724 modify start */
  // calculateOddEvenAgeDiv()
  calculateOddEvenAgeDiv(ageCalculateDiv)
  /* 20241106 #20724 modify end */
  {
    if (!this.objUser?.DateOfBirth || !this.RsvDateParam) {
      return '';
    }

    const birthDate = moment(this.objUser.DateOfBirth);
    /* 20241106 #20724 modify start */
    // const reservationDate = moment(this.RsvDateParam);
    // const age = reservationDate.diff(birthDate, 'years');
    var age = 0;
    if (ageCalculateDiv == "2") {
      // 年度末
      const rsvDate = moment(this.RsvDateParam);
      const rsvYear = rsvDate.year();
      const marchLast = moment(`${rsvYear}-03-31`);
      
      if (rsvDate.isAfter(marchLast)) {
        const nextYear = rsvYear + 1;
        age = moment(`${nextYear}-03-31`).diff(birthDate, 'years');
      } else {
        age = marchLast.diff(birthDate, 'years');
      }
    } else if (ageCalculateDiv == "3") {
      // 年末
      const rsvDate = moment(this.RsvDateParam);
      const rsvYear = rsvDate.year();
      /* 20241112 #20724 modify start */
      /* const lastDay = moment(`${rsvYear}-12-31`);
      age = lastDay.diff(birthDate, 'years'); */
      const marchLast = moment(`${rsvYear}-03-31`);

      if (rsvDate.isAfter(marchLast)) {
        age = moment(`${rsvYear}-12-31`).diff(birthDate, 'years');
      } else {
        const lastYear = rsvYear - 1;
        age = moment(`${lastYear}-12-31`).diff(birthDate, 'years');
      }
      /* 20241112 #20724 modify end */
    } else if (ageCalculateDiv == "4") {
      // 協会けんぽ
      const rsvDate = moment(this.RsvDateParam);
      const rsvYear = rsvDate.year();
      /* 20241227 #23633 modify start */
      // const aprilFirst = moment(`${rsvYear}-04-01`);
      /* 20250113 #23633 modify start */
      // const aprilFirst = moment(`${rsvYear}-03-31`);
      const aprilFirst = moment(`${rsvYear}-04-01`);
      /* 20250113 #23633 modify end */
      /* 20241227 #23633 modify end */
      
      if (rsvDate.isAfter(aprilFirst)) {
        const nextYear = rsvYear + 1;
        /* 20241227 #23633 modify start */
        // age = moment(`${nextYear}-04-01`).diff(birthDate, 'years');
        /* 20250113 #23633 modify start */
        // age = moment(`${nextYear}-03-31`).diff(birthDate, 'years');
        age = moment(`${nextYear}-04-01`).diff(birthDate, 'years');
        /* 20250113 #23633 modify end */
        /* 20241227 #23633 modify end */
      } else {
        age = aprilFirst.diff(birthDate, 'years');
      }
    } else {
      // 受診日 & その他
      age = moment(this.RsvDateParam).diff(birthDate, 'years');
    }
    /* 20241106 #20724 modify end */
    return age % 2 === 0 ? '1' : '2';
  }
  /* 20240918 #20724 add end */

  ButtonEdit() {
    //20231024 #18640 add strat
    this.objUser.PostalCode = this.objUser.PostalCode.replace(/[^\d.]/g,"");
    //20231024 #18640 add end
    if (!this.checkValidate()) {
      this.loadingSrv.setDisplay(true);
      const objSearch = {
        HTOrgCode: this.HTOrgCode,
        CoCode: this.dataReservation?.objCourse?.CoCode,
        DateOfBirth: moment(this.objUser.DateOfBirth).format('YYYYMMDD'),
        Gender: this.objUser.Gender,
        PersonFamilyDiv: this.objRsv?.PersonFamilyDiv,
        RsvYMD: this.RsvDateParam,
        HTCourseCode: this.dataReservation?.objCourse?.HTCourseCode,
      };
      const dataLocalOld = sessionStorage.getItem('DataReservationOld');
      const dataOld = JSON.parse(dataLocalOld);
      /* 20250421 #24406 modify start */
      if (!this.util.isNullOrEmpty(dataOld) && dataOld.objUser?.DateOfBirth !== this.objUser.DateOfBirth) {
        var message = this.trans.instant('MESS_CNF_EXMINF_CHANGED_HAVETO_RERESVCOURSE');
        var jumpUrl = 'exam-course-sel'
        this.dialogModalService.openConfirmModal(message).subscribe((res: DialogResult) => {
          if (res.isOk()) {
            this.objUser.DateOfBirth = moment(this.objUser.DateOfBirth).format('YYYYMMDD');
            this.dataReservation.objUser = this.objUser;
            sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
            this.isRedirecting = true;
            var genderConflict = true;
            this.router.navigate([jumpUrl], {
              queryParams: {
                mode: ScreenMode.Edit, back: '0303', genderConflict: genderConflict
              }
            });
          }
        });
        this.loadingSrv.setDisplay(false);
      }else{
      /* 20241015 #20724 delete start */
      // if (!this.util.isNullOrEmpty(dataOld) && (dataOld.objUser?.Gender !== this.objUser.Gender
      //   || dataOld.objUser?.DateOfBirth !== this.objUser.DateOfBirth)) {
      /* 20241015 #20724 delete end */
        this.personalInfInpService.CheckCourseRegistered(objSearch).subscribe(data => {
          if (data > 0) {
            /* 20240918 #20724 delete start */
            // if (dataOld.objUser?.Gender !== this.objUser.Gender) {
            /* 20240918 #20724 delete end */
              const objSearchRsv = {
                StartDate: this.dataReservation?.objRsvDateTime?.RsvYMD,
                EndDate: this.dataReservation?.objRsvDateTime?.RsvYMD,
                HTOrgCode: this.HTOrgCode,
                RsvGender: this.objUser?.Gender,
                HTCourseCode: this.dataReservation?.objCourse?.HTCourseCode,
                CoCode: this.dataReservation?.objCourse?.CoCode,
                HTSetItemCode: this.getListHTSetItemCode(this.dataReservation?.objCourse?.ListOption),
                RsvTime: this.dataReservation?.objRsvDateTime.RsvTime,
                DateOfBirth: this.objUser?.DateOfBirth,
              };
              this.rsvDetailService.checkDateTimeRsv(objSearchRsv).subscribe(data1 => {
                /* 20240918 #20724 modify start */
                // if (data1 && data1.length > 0) {
                if (data1 && data1.length > 0 &&
                    (this.util.isNullOrEmpty(this.dataReservation?.objCourse?.ListOption) || 
                    (this.dataReservation?.objCourse?.ListOption.every(option => this.util.isNullOrBlank(option.Gender) || option.Gender === '3' || option.Gender === this.objUser.Gender) &&
                    /* 20241106 #20724 modify start */
                    // this.dataReservation?.objCourse?.ListOption.every(option => this.util.isNullOrBlank(option.OddEvenAgeDiv) || option.OddEvenAgeDiv === '3' || option.OddEvenAgeDiv === this.calculateOddEvenAgeDiv())))) {
                    this.dataReservation?.objCourse?.ListOption.every(option => this.util.isNullOrBlank(option.OddEvenAgeDiv) || option.OddEvenAgeDiv === '3' || option.OddEvenAgeDiv === this.calculateOddEvenAgeDiv(this.dataReservation?.objCourse?.AgeCalculateDiv))))) {
                    /* 20241106 #20724 modify end */  
                /* 20240918 #20724 modify end */
                  this.RedirectDetail();
                } else {
                  /* 20241107 #20724 modify start */
                  // const strMess = this.trans.instant('MESS_CNF_EXMINF_CHANGED_HAVETO_RERESV');
                  var strMess = this.trans.instant('MESS_CNF_EXMINF_CHANGED_HAVETO_RERESV');
                  var url = 'reservation-date-sel';
                  /* 20241111 #20724 modify start */
                  // if (dataOld.Gender != this.objUser?.Gender) {
                  if (!this.util.isNullOrBlank(this.dataReservation?.objCourse?.ListOption) && this.dataReservation.objCourse.ListOption.some(x => x.Gender != '3' && x.Gender != this.objUser?.Gender)) {
                  /* 20241111 #20724 modify end */
                    strMess = this.trans.instant('MESS_CNF_EXMINF_CHANGED_HAVETO_RERESVCOURSE');
                    url = 'exam-course-sel'
                  }
                  /* 20241107 #20724 modify end */
                  this.dialogModalService.openConfirmModal(strMess).subscribe((res: DialogResult) => {
                    if (res.isOk()) {
                      this.objUser.DateOfBirth = moment(this.objUser.DateOfBirth).format('YYYYMMDD');
                      this.dataReservation.objUser = this.objUser;
                      sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
                      this.isRedirecting = true;
                      /* 20241015 #20724 add start */
                      var genderConflict = false;
                      if (data1 && data1.length > 0 && !this.util.isNullOrEmpty(this.dataReservation?.objCourse?.ListOption) &&
                      this.dataReservation?.objCourse?.ListOption.some(option => option.Gender !== '3' && option.Gender !== this.objUser.Gender))
                      {
                        genderConflict = true;
                      }
                      /* 20241015 #20724 add end */
                      /* 20241107 #20724 modify start */
                      // this.router.navigate(['reservation-date-sel'], {
                      this.router.navigate([url], {
                      /* 20241107 #20724 modify end */
                        queryParams: {
                          /* 20241015 #20724 modify start */
                          // mode: ScreenMode.Edit, back: '0303'
                          mode: ScreenMode.Edit, back: '0303', genderConflict: genderConflict
                          /* 20241015 #20724 modify end */
                        }
                      });
                    }
                  });
                  this.loadingSrv.setDisplay(false);
                }
              }, err => {
                this.dialogModalService.openErrorModal('MESS_EXCEPTION_OCCURRED');
                this.loadingSrv.setDisplay(false);
              }, () => {
              });
            /* 20240918 #20724 delete start */
            // } else {
            //   this.RedirectDetail();
            // }
            /* 20240918 #20724 delete start */
          } else {
            const strMess = this.trans.instant('MESS_CNF_EXMINF_HASCHANGED_RESELECT_COURSE');
            this.dialogModalService.openConfirmModal(strMess).subscribe((res: DialogResult) => {
              if (res.isOk()) {
                this.personalInfInpService.CheckExistCourse(objSearch).subscribe(data2 => {
                  if (data2 > 0) {
                    this.isRedirecting = true;
                    // Open 0305
                    this.objUser.DateOfBirth = moment(this.objUser.DateOfBirth).format('YYYYMMDD');
                    this.dataReservation.objUser = this.objUser;
                    sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
                    this.router.navigate(['exam-course-sel'], {
                      queryParams: {
                        mode: ScreenMode.Edit, back: '0303',
                      }
                    });
                  } else {
                    this.dialogModalService.openErrorModal(this.trans.instant('MESS_ERR_SELECTED_COURSE_NOT_EXIST'));
                  }
                  this.loadingSrv.setDisplay(false);
                }, err => {
                  this.loadingSrv.setDisplay(false);
                });
              }
            });
            this.loadingSrv.setDisplay(false);
          }
        }, err => {
          this.loadingSrv.setDisplay(false);
        });
      }
      /* 20250421 #24406 modify end */
      /* 20241015 #20724 delete start */
      // } else {
      //   this.isRedirecting = true;
      //   this.objUser.DateOfBirth = moment(this.objUser.DateOfBirth).format('YYYYMMDD');
      //   this.dataReservation.objUser = this.objUser;
      //   sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
      //   if (this.typeMode === 2) {
      //     this.router.navigateByUrl('reservation-detail');
      //   } else if (this.typeMode === 3) {
      //     this.router.navigate(['reservation-detail'], {
      //       queryParams: {
      //         mode: ScreenMode.Edit, date: this.RsvDateParam, num: this.RsvNumParam, htorgcode: this.HTOrgCode
      //       }
      //     });
      //   }
      // }
      /* 20241015 #20724 delete end */
    }
  }
  getListHTSetItemCode(listOption: any) {
    const lstOption = [];
    if (!this.util.isNullOrEmpty(listOption)) {
      listOption.forEach(element => {
        lstOption.push(element.HTSetItemCode);
      });
    }
    return lstOption;
  }
  RedirectDetail() {
    this.loadingSrv.setDisplay(false);
    this.objUser.DateOfBirth = moment(this.objUser.DateOfBirth).format('YYYYMMDD');
    this.dataReservation.objUser = this.objUser;
    sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
    if (this.typeMode === 2) {
      this.isRedirecting = true;
      this.router.navigateByUrl('reservation-detail');
    } else if (this.typeMode === 3) {
      this.isRedirecting = true;
      this.router.navigate(['reservation-detail'], {
        queryParams: {
          mode: ScreenMode.Edit, date: this.RsvDateParam, num: this.RsvNumParam, htorgcode: this.HTOrgCode
        }
      });
    }
  }
  checkValidate() {
    this.isConsulName = false;
    this.isKanaName = false;
    this.isKanaName2 = false;
    this.isDateOfBirth = false;
    this.isGender = false;
    this.isPhoneNum = false;
    this.isPostalCode = false;
    this.isAdress1 = false;
    let isError = false;
    let id = null;
    if (this.util.isNullOrEmpty(this.objUser.ConsulName)) {
      this.isConsulName = true;
      isError = true;
      if (this.util.isNullOrBlank(id)) {
        id = '#ConsulName';
      }
    }
    if (this.isShowKanaName) {
      if (this.util.isNullOrEmpty(this.objUser.KanaName)) {
        this.isKanaName = true;
        isError = true;
        if (this.util.isNullOrBlank(id)) {
          id = '#KanaName';
        }
      } else if (!this.rgxKatakanaFullW.test(this.util.ReplaceAll(this.objUser.KanaName, '　', ''))) {
        this.isKanaName2 = true;
        isError = true;
        if (this.util.isNullOrBlank(id)) {
          id = '#KanaName';
        }
      }
    }
    if (this.util.isNullOrEmpty(this.objUser.DateOfBirth)) {
      this.isDateOfBirth = true;
      isError = true;
      if (this.util.isNullOrBlank(id)) {
        id = '#DateOfBirth';
      }
    }
    if (this.util.isNullOrEmpty(this.objUser.Gender)) {
      this.isGender = true;
      isError = true;
      if (this.util.isNullOrBlank(id)) {
        id = '#Gender';
      }
    }
    if (this.util.isNullOrEmpty(this.objUser.PhoneNum)) {
      this.isPhoneNum = true;
      isError = true;
      if (this.util.isNullOrBlank(id)) {
        id = '#PhoneNum';
      }
    }
    if (this.util.isNullOrEmpty(this.objUser.PostalCode)) {
      this.isPostalCode = true;
      isError = true;
      if (this.util.isNullOrBlank(id)) {
        id = '#PostalCode';
      }
    }
    if (this.util.isNullOrEmpty(this.objUser.Adress1)) {
      this.isAdress1 = true;
      isError = true;
      if (this.util.isNullOrBlank(id)) {
        id = '#Adress1';
      }
    }
    if (!this.util.isNullOrBlank(id)) {
      $(id).focus();
    }
    return isError;
  }
  ChangeDOB1(pDate) {
    if (!this.util.isNullOrEmpty(pDate)) {
      this.objUser.DateOfBirth = this.util.ReplaceAll(pDate, '-', '');
      this.isDateOfBirth = false;
    } else {
      this.objUser.DateOfBirth = null;
    }
  }
  removeBoderDateOfBirth() {
    this.isDateOfBirth = false;
  }
  changeConsulName() {
    this.isConsulName = false;
  }
  changeKanaName() {
    if (!this.util.isNullOrEmpty(this.objUser.KanaName)) {
      this.isKanaName = false;
      this.isKanaName2 = false;
    }
  }
  changePostalCode() {
    if (!this.util.isNullOrEmpty(this.objUser.PostalCode)) {
      this.isPostalCode = false;
    }
  }
  removeErrorPhone() {
    this.isPhoneNum = false;
  }
  removeErrorAdress() {
    this.isAdress1 = false;
  }
  checkChangeData() {
    const dataLocalOld = sessionStorage.getItem('DataReservation');
    const dataOld = JSON.parse(dataLocalOld);
    if (!this.util.isNullOrEmpty(dataOld) && JSON.stringify(this.objUser) !== JSON.stringify(dataOld.objUser)) {
      return true;
    } else {
      return false;
    }
  }
  onKeyPressInput(event) {
    if (this.rgxKatakanaFullW.test(this.objUser.KanaName?.replace('　', '')) === true ||
      this.rgxKatakanaHalfW.test(this.objUser.KanaName?.replace(' ', '')) === true) {
      return true;
    }
    return false;
  }

  // Show poup when change data
  setDeactivateState(nextState) {
    if (this.isRedirecting) {
      this.isRedirect = true;
    }
    else {
      const checkChange = this.checkDataChangeRedirect();
      if (checkChange || this.typeMode === 2) {
         /*20240311 #21672 modify start*/
         /*const message = this.trans.instant('MESS_CNF_CHANGESCREEN_WITHOUT_REGIS');
         this.dialogModalService.openConfirmModal(message).subscribe((res: DialogResult) => {
          if (res.isOk()) {
            this.isRedirect = true;
            this.isRedirecting = true;
            this.setHTOrgName('');
            this.removeDataToSession();
            this.router.navigate([nextState]);
          }
        });*/
        const message = this.trans.instant('MESS_CNF_CHANGESCREEN_WITHOUT_REGIS');
        if (nextState == '/404') {
          
        }else{
        this.dialogModalService.openConfirmModal(message).subscribe((res: DialogResult) => {
          if (res.isOk()) {
            this.isRedirect = true;
            this.isRedirecting = true;
            this.setHTOrgName('');
            this.removeDataToSession();
            this.router.navigate([nextState]);
          }
        });
        }
        /*20240311 #21672 modify end*/
      } else {
        this.isRedirect = true;
      }
    }
  }
  // Show poup when change data
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.isRedirect;
  }
  @HostListener('window:beforeunload', ['$event']) unloadHandler(event: Event) {
    if (this.checkDataChangeRedirect() || this.typeMode === 1 || this.typeMode === 2) {
      return false;
    } else {
      return true;
    }
  }
  setHTOrgName(pHTOrgName) {
    const objHTOrg = {
      HTOrgCode: null,
      HTOrgName: pHTOrgName,
    };
    this.store.dispatch(new GetIMstHTOrg(objHTOrg));
  }
  removeDataToSession() {
    sessionStorage.removeItem('HTOrgCode');
    sessionStorage.removeItem('DataReservation');
    sessionStorage.removeItem('DataReservationOld');
  }
  checkDataChangeRedirect() {
    if (this.typeMode === 1) {
      if (!this.util.isNullOrBlank(this.dataReservation.objRsv)
       || !this.util.isNullOrBlank(this.dataReservation.objCourse)
       || JSON.stringify(this.objUserInit) !== JSON.stringify(this.objUser)) {
         return true;
      }
    }
    const dataLocal = sessionStorage.getItem('DataReservation');
    const dataLocalOld = sessionStorage.getItem('DataReservationOld');
    if (this.typeMode !== 1 && !this.util.isNullOrBlank(dataLocal) && !this.util.isNullOrBlank(dataLocalOld) && (dataLocal !== dataLocalOld
     || JSON.stringify(this.objUser) !== JSON.stringify(JSON.parse(dataLocalOld).objUser))) {
      return true;
    } else {
      return false;
    }
  }
  private preventButtonBackBrowser() {
    history.pushState(null,"", window.location.href);
  }
  /* 20231006 add #19525 start */ 
  async deleteConcurrent() {
    const pConcurrent = {
      KeyDate: this.RsvDateParam,
      KeyNum: this.RsvNumParam,
      HtOrgCode: this.HTOrgCode,
      ScreenDiv: '0'
    };
    await this.common.DeleteConcurent(pConcurrent).toPromise();
  }

  @HostListener('window:unload', ['$event'])
  unload(event: Event) {
    this.deleteConcurrent();
  }

  ngOnDestroy(): void {
    this.deleteConcurrent();
  }
  /* 20231006 add #19525 end */  
}
